export const INSUFFICIENT_ROWS_ERROR_MESSAGE =
    'Error: Insufficient data rows in the sheet.';
export const INSUFFICIENT_ALTERNATES_COLUMNS =
    'Error: All the component must have Alternate column';

export const NO_NEW_DATA_INFO = 'No new alternate added in the google sheet.';

export const NO_ALTERNATES = 'Please add alternates.';

export const CLIPBOARD_ACCESS_ERROR_MESSAGE =
    'Clipboard access was blocked. Please allow clipboard access in your browser settings or try again.';

export const CLIPBOARD_ACCESS_ERROR = 'NotAllowedError';
